import { render, staticRenderFns } from "./AddressEditForm.vue?vue&type=template&id=3c87b3c5&"
import script from "./AddressEditForm.vue?vue&type=script&lang=js&"
export * from "./AddressEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports